<template>
  <div>
    <composer
      expandable
      style="margin-bottom: 1rem;"
      :url="`/api/support/tickets/${$route.params.id}/replies`"
      @added="reply => replies.data.unshift(reply)"
    ></composer>

    <reply :reply="reply" v-for="reply in replies.data" :key="reply.id"></reply>

    <loading-box v-if="replies.loading"></loading-box>
  </div>
</template>

<script>
import Reply from "./TicketReply";
import Composer from "./TicketReplyComposer";

export default {
  props: {
    ticketId: {
      required: true
    }
  },

  components: {
    Composer,
    Reply
  },

  data() {
    return {
      replies: new window.PaginatedRemoteCollection(() => {
        return `/api/support/tickets/${this.$route.params.id}/replies`;
      }).load()
    };
  }
};
</script>
